window.Freshwater = {
    DEBUG_MODE: false,
    console: function(type, ...messages) {
        if (!this.DEBUG_MODE) return;
        const style = "background-color: #e0e8ff; color: #2a52c9; font-weight: bold; margin-bottom: 2px; padding: 2px;";
        if (["log", "warn", "error"].includes(type)) {
            console[type]("🔹 %cFreshwater", style, ...messages);
        }
    }
};

/* check for debug_mode param in URL */
(function() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("debug_mode") === "true") {
        window.Freshwater.DEBUG_MODE = true;
    }
})();


$(document).ready(function () {

	//open external links in new tab
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	//check if on Recharge Tools page
	if (window.location.href.indexOf("/tools/recurring") > -1) {
		$("html").css("font-size", "10px");
		$("body").addClass("page-recharge");
		$(".rc_layout__full").addClass("container");
		$(".rc_layout__full .col-md-6.col-md-offset-3").addClass("offset-md-3");
	}

	//hide other login form if on password page
	$("#recover-password").click(function () {
		$(".other-login-options").hide();
	});
		//check if on recover password page
		if (window.location.href.indexOf("/login#recover") > -1) {
			console.log("tahoe");
			$(".other-login-options").hide();
		}
	$(".main-login-password a").click(function () { 
		$(".other-login-options").show();
	});
	

	// Add smooth-scroll class to Shop link on homepage
	// $("#fresh-index nav li:first-child a, .home nav li:first-child a").addClass("smooth-scroll");

	//change menu links for Shop page
	// $("#fresh-page.shop nav li:first-child a").attr("href", "https://natravahealth.com/pages/shop")
	// $("#fresh-page.shop header a.header__heading-link.link").attr("href", "https://natravahealth.com/pages/shop")
	// $("#fresh-page.shop #footer .row div:nth-child(2) li:first-child a").attr("href", "https://natravahealth.com/pages/shop")

	//change menu links for Shop page
	// $("#fresh-page.shop-20servings nav li:first-child a").attr("href", "https://natravahealth.com/pages/nourish-20")
	// $("#fresh-page.shop-20servings header a.header__heading-link.link").attr("href", "https://natravahealth.com/pages/nourish-20")
	// $("#fresh-page.shop-20servings #footer .row div:nth-child(2) li:first-child a").attr("href", "https://natravahealth.com/pages/nourish-20")
	
	

	// Add smooth scrolling
	var hashTagActive = "";
	$(".smooth-scroll").on("click touchstart", function (event) {
		if (hashTagActive != this.hash) { //this will prevent if the user click several times the same link to freeze the scroll.
			event.preventDefault();
			//calculate destination place
			var dest = 0;
			// if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
			// 	dest = $(document).height() - $(window).height();
			// } else {
			// 	dest = $(this.hash).offset().top;
			// }
          dest = $(this.hash).offset().top;
			//go to destination
			$('html,body').animate({
				scrollTop: dest
			}, 2000, 'swing');
			hashTagActive = this.hash;

			//close menu
			$("#Details-menu-drawer-container").removeClass("menu-opening").removeAttr("open");
		}
	});


	//show bottom buy bar
	$(window).scroll(function () {
		if ($(document).scrollTop() > 600) {
			$('#buy-bar').addClass('show');

			// var isHovered = $('#shop').is(":hover");
			// if (isHovered) {
			// 	$('#buy-bar').removeClass('show');
			// } else {
			// 	$('#buy-bar').addClass('show');
			// }

		} else {
			$('#buy-bar').removeClass('show');
		}
	});


	// $("#shop").hover(function(){
	//   $("#buy-bar").hide();
	// });

	//footer dropdown menus
	$("#footer .menu-col h3").click(function () {
		$(this).next().toggle();
		$(this).toggleClass('is-open');
	});



	//product image carousel (main image + thumbnail navigation)
	const initFreshProductCarousel = function () {
		$('.product-image-carousel').each(function (galleryIndex) {
			const $sourceCarousel = $(this);

			if (
				$sourceCarousel.closest('.fresh-product-gallery').length ||
				$sourceCarousel.data('freshGalleryReady')
			) {
				return;
			}

			const $sourceSlides = $sourceCarousel.children();
			if (!$sourceSlides.length || !$.fn.slick) {
				return;
			}

			const galleryId = `fresh-product-gallery-${galleryIndex + 1}`;
			const mainId = `${galleryId}-main`;
			const thumbsId = `${galleryId}-thumbs`;

			const $gallery = $('<div class="fresh-product-gallery"></div>');
			const $mainCarousel = $(`<div class="fresh-product-main-carousel" id="${mainId}"></div>`);
			const $thumbsWrap = $('<div class="fresh-product-thumbs-wrap"></div>');
			const $thumbsCarousel = $(`<div class="fresh-product-thumbs-carousel" id="${thumbsId}"></div>`);

			$sourceSlides.each(function (slideIndex) {
				const $slideContent = $(this).clone();
				const $mainSlide = $('<div class="fresh-product-main-slide"></div>');
				$mainSlide.append($slideContent);
				$mainCarousel.append($mainSlide);

				const $sourceImage = $(this).is('img')
					? $(this)
					: $(this).find('img').first();

				const thumbSrc = $sourceImage.attr('src') || '';
				const thumbAlt = $sourceImage.attr('alt') || `Product image ${slideIndex + 1}`;
				const thumbSrcset = $sourceImage.attr('srcset');
				const thumbSizes = $sourceImage.attr('sizes');

				const $thumbSlide = $('<div class="fresh-product-thumb-slide"></div>');
				const $thumbButton = $(`
					<button
						type="button"
						class="fresh-product-thumb-button"
						aria-label="View image ${slideIndex + 1}"
						data-slide-index="${slideIndex}"
					></button>
				`);

				const $thumbImage = $('<img>', {
					class: 'fresh-product-thumb-image',
					src: thumbSrc,
					alt: thumbAlt
				});
				if (thumbSrcset) {
					$thumbImage.attr('srcset', thumbSrcset);
				}
				if (thumbSizes) {
					$thumbImage.attr('sizes', thumbSizes);
				}
				$thumbImage.attr('loading', 'lazy');
				$thumbImage.attr('decoding', 'async');

				$thumbButton.append($thumbImage);
				$thumbSlide.append($thumbButton);
				$thumbsCarousel.append($thumbSlide);
			});

			$thumbsWrap.append($thumbsCarousel);
			$gallery.append($mainCarousel).append($thumbsWrap);
			$sourceCarousel.replaceWith($gallery);
			$sourceCarousel.data('freshGalleryReady', true);

			$mainCarousel.slick({
				fade: true,
				swipe: true,
				arrows: false,
				autoplay: false,
				dots: false,
				infinite: true,
				speed: 700,
				slidesToShow: 1,
				adaptiveHeight: false,
				asNavFor: `#${thumbsId}`
			});

			$thumbsCarousel.slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				asNavFor: `#${mainId}`,
				focusOnSelect: true,
				infinite: true,
				arrows: true,
				prevArrow: `
					<button class="slick-prev slick-arrow" aria-label="Previous image" type="button">
						<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
						</svg>
					</button>
				`,
				nextArrow: `
					<button class="slick-next slick-arrow" aria-label="Next image" type="button">
						<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
						</svg>
					</button>
				`
			});

			$thumbsCarousel.on('click', '.fresh-product-thumb-button', function (event) {
				event.preventDefault();
				const slideIndex = Number($(this).attr('data-slide-index'));
				if (!Number.isNaN(slideIndex)) {
					$mainCarousel.slick('slickGoTo', slideIndex);
				}
			});

			$thumbsCarousel.on('keydown', '.fresh-product-thumb-button', function (event) {
				if (event.key !== 'Enter' && event.key !== ' ') {
					return;
				}
				event.preventDefault();
				const slideIndex = Number($(this).attr('data-slide-index'));
				if (!Number.isNaN(slideIndex)) {
					$mainCarousel.slick('slickGoTo', slideIndex);
				}
			});
		});
	};
	initFreshProductCarousel();

	// Ingredients carousel (replaces Flickity)
	$('.carousel-ingredients').not('.slick-initialized').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '0px',
		arrows: true,
		dots: false,
		speed: 400,
		prevArrow: `
			<button class="slick-prev slick-arrow" aria-label="Previous ingredient" type="button">
				<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
				</svg>
			</button>
		`,
		nextArrow: `
			<button class="slick-next slick-arrow" aria-label="Next ingredient" type="button">
				<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
				</svg>
			</button>
		`,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '20%'
				}
			}
		]
	});

	$('.product-image-carousel-testn26-var1').slick({
        fade: true,
        swipe: true,
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        adaptiveHeight: false
    });  
	$('.product-image-carousel-testn26-var2').slick({
        fade: true,
        swipe: true,
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        adaptiveHeight: false
    });
	$('.product-image-carousel-testn45').slick({
        fade: true,
        swipe: true,
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        adaptiveHeight: false
    });    
	////////////
	///UPSELL///
	///////////
	$(".trigger-popup").click(function (e) {
        e.preventDefault();
		$("#upsell-popup").show();
    });
	//close popup

	$(".close-popup").click(function(){
        $("#upsell-popup").fadeOut();
    });


	$("#upsell-elevatealt-sub1").click(function(){
        $("#upsell-popup").removeClass("once");
		$("#upsell-popup").addClass("sub");
		$("#upsell-popup").fadeIn();
		
    });
	$("#upsell-elevatealt-once1").click(function(){
        $("#upsell-popup").removeClass("sub");
		$("#upsell-popup").addClass("once");
		$("#upsell-popup").fadeIn();
    });	




	

});